import { render, staticRenderFns } from "./BoxHeaderIcon.vue?vue&type=template&id=3be9f406&"
import script from "./BoxHeaderIcon.vue?vue&type=script&lang=js&"
export * from "./BoxHeaderIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports